import './src/styles/tailwind.css';
import './src/styles/index.css';

import { updateClass } from './src/utils/themes';
updateClass();
